import { getClient } from '@/lib/restClient';
import { SortObject } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandCategoryService } from '@/services/BrandCategory/MenuManagementBrandCategoryService';

export type MenuManagementBrandCategoryUpdateParams = {
  associate_brand_id: number;
  title: Title;
  memo: string | null;
  brand_item_sort_objects: SortObject[];
};

export const useMenuManagementBrandUpdateCategory = async (
  id: string,
  params: MenuManagementBrandCategoryUpdateParams
): Promise<void> => {
  const menuManagementBrandCategoryService =
    new MenuManagementBrandCategoryService(getClient());
  return menuManagementBrandCategoryService.update(id, params);
};
